import FbButton from 'components/FbUI/FbButton'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'

interface SequenceEmptyStateProps {
  onCreateSequence: () => void
  onCreateWithAI: () => void
}

export function SequenceEmptyState({
  onCreateSequence,
  onCreateWithAI,
}: SequenceEmptyStateProps) {
  const { enableAISequenceGeneration } = useFeatureFlagService()
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="bg-white rounded-xl border border-line shadow-sm p-8 max-w-md text-center">
        {/* Icon with background */}
        <div className="mx-auto w-16 h-16 bg-surface-hover rounded-full flex items-center justify-center mb-5">
          <svg
            className="h-8 w-8 text-fb-dark-green"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
        </div>

        <h3 className="text-lg font-semibold text-fg mb-2">
          No email sequence
        </h3>
        <p className="text-sm text-fg-secondary mb-6 leading-relaxed">
          Create an email sequence to automate outreach for this campaign.
          Sequences allow you to send a series of personalized emails at
          scheduled intervals.
        </p>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <FbButton onClick={onCreateSequence}>Create Sequence</FbButton>
          {enableAISequenceGeneration && (
            <FbButton variant="secondary" onClick={onCreateWithAI}>
              <span className="flex items-center gap-1.5">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
                Create with AI
              </span>
            </FbButton>
          )}
        </div>
      </div>
    </div>
  )
}
